import MissionHeroSection from "../components/MissionSection/MissionHeroSection";
import MissionNavigationMenu from "../components/MissionSection/MissionNavigationMenu";

const MissionAndServices = () => {
  return (
    <div>
      <MissionHeroSection />
     <MissionNavigationMenu/>

    </div>
  );
};

export default MissionAndServices;
